
import DocumentExportFormDatev from './document-export-form-datev'

export default {
  box: DocumentExportFormDatev,
}
